export class StepData {
	name: string;
	data: { [key: string]: any };
}
